import { Component } from '@angular/core'
import { ColumnControlBaseComponent } from '../base/column-control-base.component'
import { ICustomTableColumnButton } from '../../modals/interface/custom-table.interface'

@Component({
    selector: 'app-column-control-actions',
    templateUrl: './column-control-actions.component.html',
    styleUrls: ['./column-control-actions.component.scss'],
    standalone: false
})
export class ColumnControlActionsComponent extends ColumnControlBaseComponent {
  public get actions(): ICustomTableColumnButton[] {
    return this.column.buttons
  }
}
